module.exports = __webpack_public_path__ + "img/chat-new-chat@2x.79c4d93c.png";